// extracted by mini-css-extract-plugin
export var content = "_43-3";
export var list = "_43-4";
export var settingsContent = "_43-7";
export var settingsPanel = "_43-8";
export var state = "_43-6";
export var triggerBadge = "_43-2";
export var triggerButton = "_43-1";
export var triggerShell = "_43-0";
export var unreadDot = "_43-5";